export const PAGINATION = {
  aiConversation: {
    messagesPageSize: 30,
  },
} as const;
